module.exports = __webpack_public_path__ + "static/media/pic2_trial.8994752a.png";